"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const PopupPanel_vue_1 = __importDefault(require("./common/PopupPanel.vue"));
const PreferencesManager_1 = require("../utils/PreferencesManager");
exports.default = (0, vue_1.defineComponent)({
    name: 'KeyboardShortcuts',
    components: {
        PopupPanel: PopupPanel_vue_1.default,
    },
    computed: {
        preferences() {
            return PreferencesManager_1.getPreferences;
        },
    },
});
